import styles from './RecipeListingPageLayout.module.scss';

type RecipeListingPageLayoutProps = {
  error: unknown;
  gridType: 'recipe-cards' | 'featured';
  disableFilters: boolean;
  disableSortBy: boolean;
  preloadImages: boolean;
  filterComponent: React.ReactNode;
  sortByComponent: React.ReactNode;
  recipeCardGrid: React.ReactNode;
};

const RecipeListingPageLayout = ({
  error,
  filterComponent,
  sortByComponent,
  recipeCardGrid,
  disableFilters,
  disableSortBy,
}: RecipeListingPageLayoutProps) => {
  if (error) return <div data-testid="recipe-grid-error">Failed to load recipes</div>;

  return (
    <div className={styles.recipeLayout}>
      {disableFilters ? null : <aside className={styles.filters}>{filterComponent}</aside>}
      <div className={styles.content}>
        {disableSortBy ? null : <div className={styles.sort}>{sortByComponent}</div>}
        <div className={styles.listing}>{recipeCardGrid}</div>
      </div>
    </div>
  );
};

export default RecipeListingPageLayout;
